import React from "react";
import * as Progress from "react-native-progress";
import { StyleSheet, View, TouchableOpacity, Pressable } from "react-native";

//Custom Imports
import color from "@constants/color";
import { scale } from "@utils/scale";
import t from "@constants/localization";
import { width } from "@constants/metrics";
import { CONTEST_TYPES } from "../ContestEvents";
import CustomText from "@components/CustomText";
import RightArrow from "@assets/svg/RightArrow";
import { CONTEST_EVENTS } from "@constants/analyticsEventsCT";

const PATH = "screens/Contest/contestDetails";

const YourTaskCard = ({
  navigation,
  contest_id = 0,
  item = {},
  trackEvent = () => {},
}) => {
  const {
    ordered_cx = 0,
    total_cx = 0,
    current_slab_index = 0,
    contest_type = "",
  } = item;

  const viewCustomers = () => {
    trackEvent(CONTEST_EVENTS.CONTEST_TASK_CLICKED, {
      screen: "Contest details page",
      contest_type: CONTEST_TYPES[contest_type],
      ordered_cx,
      total_cx,
      contest_id,
    });
    navigation && navigation.navigate("MyCustomers", { contest_id });
  };

  return (
    <Pressable onPress={viewCustomers} style={styles.container}>
      <CustomText
        variant="subtitle_16"
        newfont={true}
        numberOfLines={1}
        style={styles.titleText}
      >
        {t(`${PATH}/yourTask`)}
      </CustomText>
      <View style={styles.yourTaskCard}>
        <CustomText
          variant="title_18_semi"
          newfont={true}
          numberOfLines={1}
          style={styles.nameStyle}
        >
          {t(`${PATH}/placeOrderCustomerWin`)}
        </CustomText>
        <CustomText
          variant="body_text_3"
          newfont={true}
          numberOfLines={5}
          style={styles.description}
        >
          {t(`${PATH}/placeOrderCustomerWinRule`)}
        </CustomText>
        <Progress.Bar
          height={8}
          color={color.darkSkyBlue}
          width={width - 64}
          progress={
            parseInt(total_cx) === 0
              ? 0
              : parseInt(ordered_cx) / parseInt(total_cx)
          }
          borderWidth={0}
          borderRadius={10}
          style={styles.progressBar}
        />
        <CustomText
          variant="body_text_4"
          newfont={true}
          numberOfLines={1}
          style={styles.description}
        >
          {`${ordered_cx} / ${total_cx}`}
        </CustomText>
        <View style={styles.lineStyle} />
        <TouchableOpacity
          onPress={viewCustomers}
          activeOpacity={0.8}
          style={styles.cardBottomStrip}
        >
          <CustomText
            variant="body_text_3"
            newfont={true}
            numberOfLines={1}
            style={styles.titleText}
          >
            {t(`${PATH}/viewCustomers`)}
          </CustomText>
          <RightArrow
            fill={color.lightMediumBlack}
            stroke={color.lightMediumBlack}
          />
        </TouchableOpacity>
      </View>
    </Pressable>
  );
};

export default YourTaskCard;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    paddingHorizontal: 16,
    marginTop: 15,
  },
  titleText: {
    color: color.mediumBlack,
  },
  yourTaskCard: {
    flexDirection: "column",
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    borderRadius: scale(10),
    backgroundColor: color.white,
    marginTop: 8,
    paddingVertical: 16,
  },
  nameStyle: {
    color: color.color_3782A3,
    marginHorizontal: 16,
  },
  description: {
    color: color.mediumBlack,
    marginTop: 8,
    marginHorizontal: 16,
  },
  progressBar: {
    backgroundColor: color.veryLightSkyBlue,
    marginTop: 8,
    alignSelf: "center",
  },
  lineStyle: {
    height: 1,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    marginTop: 12,
  },
  cardBottomStrip: {
    paddingTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginHorizontal: 16,
    marginTop: 6,
  },
});
